import axios from 'axios';

// Get backend URL - use same origin (nginx proxy handles it)
const getBackendURL = () => {
  // Use same origin as frontend - nginx will proxy /api to backend:8000
  // This avoids SSL issues and CORS problems
  return window.location.origin;
};

const BACKEND_URL = getBackendURL();
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors and network errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Network error (backend'e bağlanılamıyor)
    if (!error.response) {
      // Daha açıklayıcı hata mesajı
      error.message = `Backend sunucusuna bağlanılamıyor. Lütfen backend'in çalıştığından emin olun. (${BACKEND_URL})`;
    }

    if (error.response?.status === 401) {
      // Login/Register/Forgot-Password sayfalarında 401 hatası normal - kendi error handling'leri var
      // Sadece diğer sayfalarında redirect yap
      const currentPath = window.location.pathname;
      const authPages = ['/login', '/register', '/forgot-password', '/reset-password', '/verify-email'];
      const isAuthPage = authPages.some(page => currentPath.includes(page));

      if (!isAuthPage) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;